const zh = {
  translation: {
    welcome: "欢迎！",
    change_language: "切换语言",
    about: "关于页面",
    clear_chat_history: "清空聊天记录",
    logout: "退出登录",
    settings: "设置",
    user: {
      profile: "学员信息",
      user_id: "用户ID",
      login_name: "登录名",
      mobile: "手机号",
      organization: "单位",
      edit: "编辑",
      edit_coming_soon: "编辑功能即将上线",
      not_logged_in: "未登录，请先登录后查看个人信息",
    },
    video: {
      play: "播放",
      pause: "暂停",
      forward_10: "快进10秒",
      rewind_10: "快退10秒",
      fullscreen: "全屏"
    }
    ,
    assist: {
      start_guide: "点击开始引导",
      play_guide: "播放引导",
      close: "关闭",
      enable_sound: "开启声音",
      skip: "跳过",
      entered_chat: "已进入对话"
    }
    ,
    server_error: "服务器错误，请稍后再试"
    ,
    course: {
      fetch_failed: "获取表格数据失败",
      title: "课程列表",
      no_data: "暂无课程数据",
      study_course: "我要学习课程《{{name}}》",
      not_started: "未学",
      in_progress: "学习中",
      completed: "已学"
    }
    ,
    enroll: {
      title: "培训课程报名表",
      class: "报名班级",
      select_class: "请选择班级",
      select_class_required: "请选择要报名的班级",
      submit_failed: "报名提交失败",
      name: "姓名",
      gender: "性别",
      male: "男",
      female: "女",
      id_card: "身份证号",
      organization_type: "单位类别",
      organization: "工作单位",
      position: "职务职称",
      mobile: "手机号码",
      email: "电子邮箱",
      address: "通讯地址",
      photo: "照片（选填）",
      submit: "提交报名",
      reset: "重置",
      cancel: "取消报名",
      enter_name: "请输入姓名",
      select_gender: "请选择性别",
      enter_id_card: "请输入身份证号",
      invalid_id_card: "身份证号格式不正确",
      enter_mobile: "请输入手机号码",
      invalid_mobile: "手机号格式不正确",
      select_org_type: "请选择单位类别",
      enter_org: "请输入工作单位",
      select_position: "请选择职务职称",
      enter_position: "请输入职务职称",
      enter_email: "请输入电子邮箱",
      invalid_email: "邮箱格式不正确",
      enter_address: "请输入通讯地址",
      upload_one_photo: "请上传且仅上传一张照片",
      only_images: "仅支持上传图片文件",
      size_exceed: "图片大小不能超过 5MB",
      upload: "上传",
      photo_desc: "选填。用于发放证书，支持 JPG/PNG，大小不超过 5MB",
      submit_success: "提交成功，已进入审核",
      enroll_info_submitted: "报名信息已提交，等待班主任审核",
      waiting_approval: "您的报名已提交，正在等待班主任审核，请耐心等待。审核通过后即可开始学习。",
      autofill_notice: "已根据您在对话中提供的信息自动填写，请核对并补全缺失项后提交。",
      upload_failed: "上传失败",
      enter_mobile_required: "请输入手机号码",
      invalid_mobile_format: "手机号格式不正确",
      select_org_type_required: "请选择单位类别",
      enter_org_required: "请输入工作单位",
      select_position_required: "请选择职务职称",
      enter_email_required: "请输入电子邮箱",
      invalid_email_format: "邮箱格式不正确",
      enter_address_required: "请输入通讯地址",
      preview: "预览"
    }
    ,
    login: {
      welcome: "欢迎使用",
      brand: "山海智训",
      wechat_login: "微信登录"
    },
    logout: "退出登录",
    talk: {
      thinking: "正在思考中...",
      open_dynamic: "打开动态",
      upload_video: "打开上传视频",
      open_enroll: "打开报名表",
      open_table: "打开表格",
      open_course_table: "打开课表",
      open_course: "打开课程",
      open_class_list: "打开班级列表"
    }
    ,
    action_card: {
      enroll_title: "培训课程报名",
      enroll_desc: "点击进入报名表填写；也可在对话中告诉我您的姓名、身份证、单位等信息，我会帮您自动填写。",
      video_title: "继续学习",
      video_desc: "点击打开推荐课程视频，开始或继续学习。",
      schedule_title: "查看学习进度",
      schedule_desc: "点击查看您的课程表与学习进度。",
      class_list_title: "查看班级列表",
      class_list_desc: "浏览可报名或已加入的培训班级。",
      certificate_title: "查看证书",
      certificate_desc: "点击查看你的结业证书。",
      generic_title: "查看详情",
      generic_desc: "点击进入对应功能页面。"
    }
    ,
    input: {
      voice_not_available: "语音功能暂未开放，敬请期待",
      file_too_large: "文件 {{name}} 超过500MB限制",
      upload_success: "{{name}} 上传成功",
      upload_failed: "{{name}} 上传失败",
      upload_error: "{{name}} 上传失败: {{error}}",
      file_deleted: "文件已删除",
      enter_question: "请输入您的问题",
      upload_file: "上传文件",
      voice_input: "语音输入",
      voice_listening: "正在聆听，请说话…",
      voice_transcribing: "正在识别语音…",
      voice_stop: "点击停止录音",
      voice_not_supported: "当前浏览器不支持语音输入",
      voice_no_speech: "未检测到语音，请重试",
      voice_permission_denied: "请允许麦克风权限后重试",
      voice_error: "语音识别失败，请重试",
      delete_file: "删除文件",
      processing: "正在处理您的问题...",
      ask_question: "提出您的问题"
    },
    energy: {
      label: "能量",
      summary: "本月总能量 {{total}}，已用 {{used}}，剩余 {{remain}}",
      consumed: "本次消耗 {{cost}} 能量",
      insufficient: "能量不足，无法继续使用 AI 功能",
      unavailable: "暂无法获取能量信息"
    }
    ,
    talk_input: {
      ask_any_question: "请问我任何问题"
    }
    ,
    quick_questions: {
      enroll: "我要报名",
      continue_learning: "继续学习",
      learning_progress: "学习进度",
      take_course: "我要上课",
      chat: "随便聊聊",
      query: "我要查询",
      upload_video: "我要上传视频"
    }
    ,
    video_player: {
      fetch_video_failed: "获取视频信息失败",
      save_progress_failed: "保存观看进度失败",
      updating_learning_record: "正在更新您的学习记录，请稍等！",
      lesson_complete_message: "本节课程学习完成，希望今天的内容能为你带来新的启发，期待你在实践中不断进步！",
      course_completed: "完成课程",
      course_interrupted: "中断课程",
      send_progress_failed: "发送观看进度到AI失败:",
      back_to_list: "返回列表",
      speed: "倍数",
      play_count: "播放次数"
    }
    ,
    video_list: {
      title: "视频课程列表",
      total_courses: "共 {{count}} 门课程",
      learning_progress: "学习进度",
      continue_learning: "继续学习",
      start_learning: "开始学习"
    }
    ,
    course_types: {
      required: "必修课",
      elective: "选修课",
      lab: "实验课"
    }
    ,
    class_list: {
      title: "班级列表",
      sort: "排序",
      class_name: "班级名称",
      program_type: "培训类型",
      deadline: "截止时间",
      action: "操作",
      join_class: "加入班级",
      no_deadline: "无截止时间",
      fetch_failed: "获取表格数据失败"
    }
    ,
    common: {
      back: "返回",
      loading: "数据加载中...",
      no_data: "暂无数据"
    }
    ,
    window: {
      collapse_display: "收起展示",
      close_modal: "关闭弹窗",
      display_digital_human: "智能助教",
      display_video: "课程视频",
      chat_panel: "对话区"
    }
    ,
    certificate: {
      title: "结业证书",
      download: "下载证书",
      downloading: "正在生成…",
      download_failed: "证书下载失败，请稍后重试",
      paused: "结业证书模板正在更新中，证书发放已暂停。新版证书上线后会开放领取，请留意班级通知。"
    }
    ,
    table: {
      course_type: "课程类型"
    }
    ,
    teacher_profile: {
      title: "教师简介",
      job_title: "职称",
      position: "职务",
      phone: "电话",
      email: "邮箱",
      work_unit: "工作单位",
      bio: "简介",
      view_photo: "查看大图"
    },
    course_schedule: {
      title: "课程表",
      title_lessons: "课时列表",
      title_agenda: "培训议程",
      program_type: "培训类型",
      has_video: "有视频",
      no_video: "无视频",
      video_status: "视频",
      sort: "排序",
      course_type: "课程类型",
      name: "名称",
      learning_progress: "学习进度",
      teacher: "教师",
      not_started: "未开始",
      fetch_failed: "获取表格数据失败"
    },
    lesson_list: {
      title: "课时列表",
      has_video: "有视频",
      no_video: "无视频"
    },
    program_type: {
      agenda_required: "需议程",
      agenda_optional: "议程可选",
      agenda_not_required: "无需议程"
    }
  }
};

export default zh;
